import { useEffect, useReducer } from 'react'
import { useDispatch } from 'react-redux'
import useScid from 'common/use-scid'
import api from 'common/api'
import { actions as snactions } from 'store/snackbar'

export const INITIAL_STATE = {
  error: false,
  loading: true,
  stateDetails: [],
}

export const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return {
        ...state,
        error: false,
        loading: true,
      }
    case 'loaded': {
      const { data } = action
      return {
        ...state,
        error: false,
        loading: false,
        stateDetails: data.high_schools,
      }
    }
    case 'error': {
      return {
        ...state,
        error: true,
        loading: false,
      }
    }
  }
}

const useStateDetails = (state) => {
  const scid = useScid()
  const [{ error, loading, stateDetails }, dispatch] = useReducer(reducer, INITIAL_STATE)

  const snackDispatch = useDispatch()

  useEffect(() => {
    dispatch({ type: 'loading' })
    api
      .get(`/api/colleges/${scid}/metrics/by-location/${state}`)
      .then((data) => dispatch({ type: 'loaded', data }))
      .catch(() => {
        dispatch({ type: 'error' })
        snackDispatch(snactions.addSnackbarItem('An error occurred while retrieving location metrics'))
      })
  }, [scid, state, snackDispatch])

  return {
    error,
    loading,
    stateDetails,
  }
}

export default useStateDetails
